import React from 'react';
import { attackSurfaces } from '../data/site';
export function AttackSurfaces() {
  return <section id="coverage" aria-labelledby="coverage-heading" className="border-t border-line" data-id="element-9" data-mp="3trjblzra64rx">
      <div className="mx-auto grid w-full max-w-[1440px] grid-cols-1 gap-12 px-6 py-20 lg:grid-cols-[380px_1fr] lg:gap-20 lg:px-16 lg:py-24" data-id="element-10" data-mp="3osg3g6g07ifq">
        <div data-id="element-11" data-mp="3jvfzc12pspr9">
          <h2 id="coverage-heading" className="text-[32px] font-extrabold leading-tight tracking-tightest text-heading" data-id="element-12" data-mp="3jvzgvgogdc4r">
            Every attack surface an autonomous vehicle exposes
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted" data-id="element-13" data-mp="bm6aoatl8rdw">
            Autonomy widens the perimeter: sensors, actuators, radios and apps all become reachable.
            Ziaxen maps each one to a defended control.
          </p>
        </div>

        <ul className="divide-y divide-line border-y border-line" data-id="element-14" data-mp="1441tjwkhfafq">
          {attackSurfaces.map(surface => <li key={surface.id} className="flex flex-col gap-2 py-6 sm:flex-row sm:items-center sm:justify-between sm:gap-8" data-id="element-15" data-mp="z9xm7c7b10e4">
              <div className="max-w-[560px]" data-id="element-16" data-mp="325g1jv43bbde">
                <h3 className="text-base font-bold text-heading" data-id="element-17" data-mp="2nhuvptftyy1s">{surface.name}</h3>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-18" data-mp="2nfqszeto4533">{surface.summary}</p>
              </div>
              <span className={`inline-flex w-fit shrink-0 items-center gap-2 rounded-full border px-3 py-1 text-[11px] font-bold uppercase tracking-[0.05em] ${surface.status === 'Protected' ? 'border-secure/30 bg-secure/10 text-secure' : 'border-accent/25 bg-accent/[0.07] text-accent-quiet'}`} data-id="element-19" data-mp="2eh6iv226b3qh">
                <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" data-id="element-20" data-mp="2rmb0y2r4ebf" />
                {surface.status}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}